export { EmojiStoreService } from './emoji-store.service';
